import PropTypes from "prop-types"

import { SectionTitle } from "areas/product/jewlr/components"
import Image from "components/ui/image"
import { cn } from "styles/utils"

const magazines = [
  {
    alt: "The Oprah Magazine",
    height: "29px",
    image: require("images/product/info/as_seen_in/The-Oprah-logo.svg"),
    key: "the-oprah-magazine",
    style: {
      "--aspect-ratio": "157 / 29",
    },
    width: "157px",
  },
  {
    alt: "People",
    height: "37px",
    image: require("images/product/info/as_seen_in/People-logo.svg"),
    key: "people",
    style: {
      "--aspect-ratio": "92 / 37",
    },
    width: "92px",
  },
  {
    alt: "Fashion",
    className: "w-(--base-width) desktop:w-(--desktop-width)",
    height: "96px",
    image: require("images/product/info/as_seen_in/fashion-logo.svg"),
    key: "fashion",
    style: {
      "--aspect-ratio": "435 / 96",
      "--base-width": "109px",
      "--desktop-width": "130px",
    },
    width: "435px",
  },
  {
    alt: "CNN",
    className: "w-(--base-width) desktop:w-(--desktop-width)",
    height: "40px",
    image: require("images/product/info/as_seen_in/CNN-logo.svg"),
    key: "cnn",
    style: {
      "--aspect-ratio": "86 / 40",
      "--base-width": "73px",
      "--desktop-width": "85px",
    },
    width: "86px",
  },
  {
    alt: "US Weekly",
    className: "w-(--base-width) desktop:w-(--desktop-width)",
    height: "41px",
    image: require("images/product/info/as_seen_in/US-weekly-logo.svg"),
    key: "us-weekly",
    style: {
      "--aspect-ratio": "53 / 41",
      "--base-width": "44px",
      "--desktop-width": "52px",
    },
    width: "53px",
  },
]

const LandingAsSeenIn = ({ element, lazyload = true }) => {
  const { containerProps, gridProps, logoContainerProps, wrapperProps } =
    element?.data || {}
  const { className: containerClassName, ...restContainerProps } =
    containerProps || {}
  const { className: gridClassName, ...restGridProps } = gridProps || {}
  const { className: logoContainerClassName, ...restLogoContainerProps } =
    logoContainerProps || {}
  const { className: wrapperClassName, ...restWrapperProps } =
    wrapperProps || {}

  return (
    <div
      className={cn("bg-grey-3 py-32", wrapperClassName)}
      {...restWrapperProps}
    >
      <div
        className={cn(
          "contained desktop:max-w-1440 tablet:px-0",
          containerClassName
        )}
        {...restContainerProps}
      >
        <div
          className={cn(
            "desktop:gap-40 desktop:justify-between desktop:px-32 grid items-center justify-center gap-24 px-16",
            gridClassName
          )}
          {...restGridProps}
        >
          <SectionTitle>AS FEATURED IN</SectionTitle>
          <div
            className={cn(
              "desktop:justify-between desktop:col-start-2 desktop:col-span-3 desktop:gap-24 desktop:row-start-1 tablet:gap-x-48 tablet:px-0 col-span-full col-start-1 row-start-2 flex w-full flex-1 flex-wrap items-center justify-center gap-24",
              logoContainerClassName
            )}
            {...restLogoContainerProps}
          >
            {magazines.map((magazine) => (
              <Image
                alt={magazine.alt}
                className={cn("aspect-(--aspect-ratio)", magazine.className)}
                height={magazine.height}
                key={magazine.key}
                lazyload={lazyload}
                src={magazine.image}
                style={magazine.style}
                width={magazine.width}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

LandingAsSeenIn.propTypes = {
  element: PropTypes.object,
  lazyload: PropTypes.bool,
}

export default LandingAsSeenIn
